/**
 * 快捷指令模板（迁自 agent-web gameplay-prompts.ts 的 VIDEO_TO_PLAYABLE_PROMPT）。
 * 点击后填入输入框（不自动发送），供用户按需编辑。
 */

/**
 * 视频转试玩快捷指令（生成模式，非玩法）。
 * 这是发给 AI 模型的生成指令，直接描述期望的试玩效果，让模型据此生成互动配置。
 * 注：段间切换无过渡动画（直接切换 video src），仅结束页支持进入动画，故只描述结束页动画。
 */
export const VIDEO_TO_PLAYABLE_PROMPT = `试玩主题：鲜花
帮我生成一个视频转试玩广告
我将上传多个视频文件，请按照上传顺序将它们作为视频片段依次拼接播放

各段视频的播放与互动行为：
- 第1段视频：播放结束后定格在最后一帧，屏幕中央偏下位置右方区域设置点击热区，点击后切换到第2段视频
- 第2段视频：正向循环播放直到用户操作，向上滑动切换到第3段视频
- 第3段视频：播放完成后自动跳转到第4段视频
- 第4段视频：播放完成后来回循环（pingpong），屏幕正下方区域偏左一点设置任意滑动热区，滑动后切换到结束页

粒子特效：
- 第1段视频播放到第1秒时在屏幕中央触发烟花粒子
- 第2段视频播放到第3秒时在屏幕中央触发彩纸粒子
- 第3段视频播放结束时在屏幕中央触发红包粒子
- 第4段视频播放到第1秒时在屏幕中央触发金币粒子

文字叠加：
- 第1段视频从第2秒开始在屏幕水平垂直居中位置展示文字："快来试试看！"
- 文字颜色黄色，描边白色，文字大一点，醒目一点，并有心跳动画

音效配置：
- 请配置我指定的背景音乐和点击/滑动等基础音效，并静音视频原声

结束页配置：
- 结束页请配置我上传的图片，图片名称包含"结束页"或"结算页"的图片作为结束页背景
- 结束页触发install的方式为全屏点击
- 请使用我上传的 cta 按钮图片作为 cta 按钮背景，如果没有上传图片则使用 ai 生图

引导手势：
- 第1段视频：从第1秒开始在点击热区中心（屏幕中央偏下右方区域）展示引导手势图，手势方向与该段互动一致（按下），脉冲动画提示点击
- 第2段视频：从第1秒开始在屏幕中央展示上滑引导手势图，并配合向上位移的滑动动画
- 第4段视频：从第1秒开始在屏幕正下方偏左的滑动热区中心展示任意滑动引导手势图
- 引导手势图大小约占屏宽 18%，仅在等待用户操作时显示，用户完成对应互动后立即隐藏
- 自动跳转的段落（第3段）无用户互动，不添加引导手势
- 请使用我的引导手势图片，如果没有上传图片则使用 ai 生图

屏幕方向：竖屏

提示：位置描述支持网格坐标（如「网格 E6」对应 x=45%-55% y=45%-55%）、锚点（cta/center/top-left/bottom-right）、百分比（x=50% y=50%）三种格式，AI 会自动解析。精确坐标有助于图层避免重叠、留足安全区。`;

